import React from "react";
import PropTypes from "prop-types";

const trackClick = () => {
  if (typeof ga === "function") {
    ga("send", "event", {
      eventCategory: "Outbound Link",
      eventAction: "click",
      eventLabel: "Download "
    });
  }
};

const DownloadLink = props => (
  <a
    download
    className="DownloadLink"
    href={props.content}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => trackClick()}
  >
    <span className="DownloadLink__icon">{props.icon}</span>

    {props.children}
  </a>
);

DownloadLink.propTypes = {
  icon: PropTypes.node,
  content: PropTypes.string.isRequired
};

export default DownloadLink;



// WEBPACK FOOTER //
// ./src/components/DownloadLink.js